module.exports = __webpack_public_path__ + "static/media/mySql.be984887.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Skills/mySql.png
// module id = 118
// module chunks = 0